import useFetch from '../../../hooks/useFetch';
import rideApi from '../rideApi';

export default function useTerminerRideApi() {
    return useFetch(rideApi.terminer);
}
